module.exports = __webpack_public_path__ + "img/dentalfit_2_a.9353a82d.jpg";